import { styled } from '@mui/material/styles';
import { Box, InputBase, Typography } from '@mui/material';

// 직인/로고 등록·수정 모달 styled (Figma 5154:9321 등록 / 5154:9392 수정)
// 헤더/콘텐츠/카드/푸터 셸은 LogoSealModalStyled 에서 재사용하고, 여기엔 폼/업로드 전용만 둔다.

// 등록·수정 모달은 목록 모달보다 좁다 (≈432px)
export const EditContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '432px',
  maxWidth: 'calc(100vw - 32px)',
  maxHeight: '90vh',
  background: '#fff',
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  outline: 'none',
});

// 제목 입력 그룹
export const FieldGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
});

export const FieldLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#141414',
});

export const TitleInput = styled(InputBase)({
  height: '44px',
  padding: '12px 16px',
  border: '1px solid #A6A6A6',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 500,
  color: '#333',
  '& input::placeholder': { color: '#A6A6A6', opacity: 1 },
});

// 사진 업로드 그룹
export const UploadGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
  width: '350px',
  maxWidth: '100%',
});

export const UploadHintRow = styled(Box)({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  width: '100%',
});

export const UploadHintLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#141414',
  whiteSpace: 'nowrap',
});

export const UploadHintText = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  color: '#A6A6A6',
});

// 빈 업로드 박스 (+ 아이콘)
export const UploadBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '160px',
  height: '160px',
  border: '1px solid #A6A6A6',
  borderRadius: '8px',
  background: '#fff',
  cursor: 'pointer',
  color: '#A6A6A6',
});

// 업로드된 이미지 미리보기
export const ImagePreview = styled(Box)({
  width: '160px',
  height: '160px',
  borderRadius: '8px',
  background: '#f2f2f2',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  '& img': {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
});

// 이미지 재업로드 버튼 (수정 모달)
export const ReuploadButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'center',
  width: '240px',
  height: '44px',
  border: '1px solid #141414',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 600,
  color: '#141414',
});

export const BottomNote = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  color: '#737373',
  textAlign: 'center',
});
